import { createContext, Dispatch, SetStateAction } from "react";

import { IExtendableDto } from "@ryde/shared";

interface ITableItemContext {
  groupingValue: IExtendableDto[keyof IExtendableDto] | undefined | null;
  collapsed?: boolean;
  setCollapsed?: Dispatch<SetStateAction<boolean>>;
}

export const TableItemContext = createContext<ITableItemContext>({
  groupingValue: undefined,
  collapsed: false,
});
